import {
  Token,
  isNormalPositive,
} from '@bifrost-platform/bifront-sdk-react-biholder';
import { useMemo } from 'react';
import { FlexBox } from '@/components/atom/FlexBox';
import { StyledText } from '@/components/atom/Text';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from '@/components/atom/Tooltip';
import useGetCurrencyString from '@/hooks/store/useGetCurrencyString';
import { formatAmount, formatAmountOnHover } from '@/libs/formatNumber';
import TokenIcon from '../TokenIcon';
import Skeleton from '../atom/Skeleton';

interface Props {
  token?: Token;
  value?: string;
  price?: string;
  isLoading?: boolean;
}

export default function AssetValueRow({
  token,
  value,
  price,
  isLoading,
}: Props) {
  // currency
  const { getAmountValue, formatCurrencyValue, getNumberWithCurrencyReplace } =
    useGetCurrencyString();

  // memo
  const amountValue = useMemo(
    () =>
      isNormalPositive(price, true)
        ? getAmountValue(value, price)
        : formatCurrencyValue(
            isNormalPositive(value, true) ? value : '0',
            token
          ),
    [price, getAmountValue, formatCurrencyValue, value, token]
  );

  return (
    <FlexBox $flex $align="center" as="li" $gap="md">
      <TokenIcon isHideChain size={40} {...token} />
      {isLoading ? (
        <Skeleton $grow={1} $height={52} />
      ) : (
        <>
          <FlexBox $flex $direction="column">
            <Tooltip placement="top-end" offset={14}>
              <TooltipTrigger>
                <StyledText $fontSize="lg" $fontWeight="black">
                  {formatAmount(value)} {token?.symbol}
                </StyledText>
              </TooltipTrigger>
              <TooltipContent>
                <TooltipArrow />
                <StyledText $fontSize="xs" $fontWeight="medium">
                  {formatAmountOnHover(value)} {token?.symbol}
                </StyledText>
              </TooltipContent>
            </Tooltip>
            <StyledText $textColor="textGray">
              {getNumberWithCurrencyReplace(amountValue)}
            </StyledText>
          </FlexBox>
        </>
      )}
    </FlexBox>
  );
}
